
class MobileAppCreateController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, BranchService, $q, $scope, MobileAppService) {
        this.MobileAppService = MobileAppService;
        this.User = User;

        this.model = {
            platform: 'android',
            version: '',
            downloadLink: '',
            branchId: User.getUser().branchId
        }
    }

    $onInit() { }

    submit() {
        this.loading = true;
        this.MobileAppService.saveApp({
            platform: this.model.platform,
            version: this.model.version,
            downloadLink: this.model.downloadLink,
            branchId: this.model.branchId
        })
            .then((data) => {
                this.loading = false;
                window.history.go(-1);
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.loading = false;
            })

    }

}
export default MobileAppCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/create/mobile_app.create.controller.js